import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  consumeAccessToken,
  saveViewerSession,
} from '../../services/communityService';
import './Community.css';

const CommunityAccessPage = () => {
  const { t } = useTranslation('community');
  const { isRTL } = useLanguage();
  const navigate = useNavigate();
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [canContinue, setCanContinue] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const consume = async () => {
      if (!token) {
        setLoading(false);
        setError(t('access.invalid'));
        return;
      }

      try {
        setLoading(true);
        const payload = await consumeAccessToken(token);
        if (cancelled) return;

        saveViewerSession({
          viewerToken: payload.viewer_token,
          memberId: payload.member_id,
          allowedChannels: payload.allowed_channels || {},
        });

        setCanContinue(true);
      } catch (err) {
        console.error('Failed to consume community access token:', err);
        if (!cancelled) {
          setError(err.message || t('access.invalid'));
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    consume();

    return () => {
      cancelled = true;
    };
  }, [token, t]);

  return (
    <div className="community-public-wrap" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="community-public-card">
        <h2 className="community-page-title" style={{ fontSize: 24 }}>{t('access.title')}</h2>

        {loading && <p className="community-skeleton" style={{ marginTop: 12 }}>{t('access.subtitle')}</p>}

        {!loading && error && <div className="community-message error">{error || t('access.invalid')}</div>}

        {!loading && canContinue && (
          <button className="community-btn" onClick={() => navigate('/community/feed')}>
            {t('access.continue')}
          </button>
        )}
      </div>
    </div>
  );
};

export default CommunityAccessPage;
